import { actRequest, type RESP } from "./request"

export type CheckUserResult = {
    results: {
        userId: string
        sdkId: string
        nickname: string
        level: number
        avatar: {
            url: string
            type: string
            id: string
        }
        lastOnlineTs: number
        token?: string
    }
    cache: boolean
    token: string
}

export const requestLogin = async (token: string, sdkId: string, channel = "official") => {
    return actRequest.post<null, RESP<CheckUserResult>>(
        `/api/activities/${__ACTIVITY_CID}/account/checkuser`,
        {
            sdkId,
            token,
            channel,
        },
    )
}

export const requestGetRole = async () => {
    return actRequest.get<null, RESP<CheckUserResult>>(
        `/api/activities/${__ACTIVITY_CID}/account/checkuser`,
    )
}

export const requestLoginByAuth = async (auth: string) => {
    return actRequest.post<null, RESP<CheckUserResult>>(
        `/api/activities/${__ACTIVITY_CID}/account/checkuser`,
        { auth },
    )
}

export const requestLogout = async () => {
    return actRequest.post<null, RESP<null>>(
        `/api/activities/${__ACTIVITY_CID}/account/logout`,
    )
}
